<template>
	<div class="main">
		<div class="cashier-title">
			<div class="logo">
				<img class="logo-img" src="@/assets/img/title_pc_new.png" alt>
				<img class="logo-close" src="@/assets/img/pay-close.png" @click="handlePayCloseClick">
			</div>
		</div>
		<div class="banner">
			<div class="user-info">
				<div class="pay">
					<span>You are about to pay...</span>
					<!-- <span class="number">₦{{defaultParms && defaultParms.payAmount&&defaultParms.payAmount.value}}</span> -->
          <span class="number">
            {{ defaultParms && defaultParms.payAmount && $customCurrencyFormat(defaultParms.payAmount.currency) + defaultParms.payAmount.value }}
          </span>
				</div>
				<div class="order">
					<span class="order-mr">Order number: {{defaultParms && defaultParms.orderNo||""}}</span>
					<span>Payee: {{defaultParms&&defaultParms.mchShortName||""}}</span>
				</div>
			</div>
		</div>
		<div class="content">
			<!-- 银行支付方式选择模块 -->
			<div class="pay-method-select-module" v-if="!payModuleType || payModuleType === 'select'">
				<ul>
					<li
						class="pay-method-select-item"
						v-for="item in payMethodList"
						:key="item.value"
						@click="handlePayMethodChange(item)"
					>
						<span class="pay-method-select-icon">
							<img class="pay-method-select-icon-img" :src="item.icon" >
						</span>
						<div class="pay-method-select-content">
							<span class="pay-method-select-label">{{ item.label }}</span>
							<span class="pay-method-select-new" v-if="item.isNew"></span>
							<span class="pay-method-select-arrow"></span>
						</div>
					</li>
				</ul>		
			</div>
			<!-- 银行支付信息模块 -->
			<div class="pay-method-use-module" v-if="payModuleType === 'pay'">
				<div class="pay-method-use-title-module">
					{{ payComponent.label }}
				</div>
				<div class="pay-method-use-info-module">
					<component
						v-bind:is="payComponent.value"
						:defaultParms="defaultParms"
						:authState="authState"
						:country="country"
						:countryCode="countryCode"
						@handlePayStep="handlePayStep"
						@handleOrderStatus="getOrderStatus"
					/>
				</div>
			</div>
		</div>
		<!-- 安全信息 -->
		<p class="footer">
			<span></span> Secured by
			<a href="https://opayweb.com/">OPay</a>
		</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				country: "NG",
				countryCode: "Nigeria", //国家‘
				authState: "", //balance商户校验状态  返回 VerifyPIN、VerifyOTP 分别跳转到 otp or pin
				defaultParms: null,
				orderParms: null,
				payMethodList: [], // 支付列表
				payModuleType: "select", // select: 选择支付方式, pay: 支付
				// payModuleType: "pay", // select: 选择支付方式, pay: 支付
				payComponent: {
					// label: "Pay with Bank Transfer",
					// value: "cashier-bank-transfer"
				}, // 支付组件名称
				timer: null,
				timerInterval: 5 // 定时器间隔 (单位:秒)
			};
		},
		watch: {},
		created() {
			let { data } = this.$route.query;
			this.defaultParms = JSON.parse(data || "{}");
		},
		mounted() {
			this.load();
		},
		destroyed() {
			this.clear();
		},
		methods: {
			load() {
				sessionStorage.setItem("opay-parms", JSON.stringify(this.defaultParms));
				this.initPayMethodList();
				this.pollingOrderStatus();
			},
			clear() {
				clearInterval(this.timer);
			},
			// 初始化支付方式列表
			initPayMethodList() {
				function loadImg(name) {
					return require(`@/assets/img/pay-method-icon/${name}.png`)
				}
				const payMethodMap = {
					bankCard: {
						label: "Pay with Card",
						value: "cashier-card",
						icon: loadImg("pay-card")
					},
					bankAccount: {
						label: "Pay with Bank Account",
						value: "cashier-bank",
						icon: loadImg("pay-bank-account")
					},
					bankTransfer: {
						label: "Pay with Bank Transfer",
						value: "cashier-bank-transfer",
						icon: loadImg("pay-bank-transfer"),
						isNew: true
					},
					bankUSSD: {
						label: "Pay with USSD",
						value: "cashier-bank-ussd",
						icon: loadImg("pay-ussd"),
						isNew: true
					},
					account: {
						label: "Pay with OPay-Wallet",
						value: "cashier-balance",
						icon: loadImg("pay-wallet")
					},
					qrcode: {
						label: "Pay with OPay-QR",
						value: "cashier-qrcode",
						icon: loadImg("pay-or")
					}
				}
				let { payMethods = [] } = this.defaultParms;
				let t = [];

				payMethods.forEach(item => {
					if (item in payMethodMap) {
						t.push(payMethodMap[item]);
					}
				});

				this.payMethodList = t
			},
			// 获取订单状态
			getOrderStatus(callback) {
				let data = JSON.parse(JSON.stringify(this.defaultParms));
				this.$axios
					.post("/apiCashier/api/cashier/opayOrderStatus", data)
					.then(response => {
						let transferData = {};
						const { code, data, message } = response.data || {};
						if (code === "00000") {
							this.orderParms = data;
							// 成功跳转支付成功页面
							if (data.orderStatus === "SUCCESS" || data.orderStatus === "FAIL") {
								let parms = {
									orderStatus: data.orderStatus,
									// reasonMsg: this.orderParms.message
									// 2020.1.2 李勇和黄晓东商量更改的错误信息字段
									reasonMsg: data.errorMsg || ""
								};
								this.handleRedirectPayResultPage("/status", parms);
							} else if (data.orderStatus === "PENDING") {
								transferData = data;
							}
							transferData.customStatus = true;
						} else {
							transferData.customStatus = false;
							transferData.customMsg = message;
						}
						callback && typeof callback === 'function' && callback(transferData)
					})
					.catch(error => {
						this.$message({
							type: "error",
							customMsg: error.toString()
						});
						callback && typeof callback === 'function' && callback({
							customStatus: false,
							customMsg: error.toString()
						});
						throw error;
					});
			},
			// 轮询订单状态
			pollingOrderStatus() {
				clearInterval(this.timer);
				this.timer = setInterval(() => {
					this.getOrderStatus();
				}, this.timerInterval * 1000);
			},
			// 切换支付方式
			handlePayMethodChange(item) {
				this.$closeLoading();
				this.payModuleType = 'pay';
				this.payComponent = item;
			},
			// 切换支付步骤
			handlePayStep(step) {
				this.$closeLoading();
				this.payModuleType = step || "select"
			},
			// 关闭支付
			handlePayCloseClick() {
				if (window.confirm("Are you sure you want to cancel this payment?")) {
					const { returnUrl } = this.defaultParms || {}
					window.location.href = returnUrl;
				}
			},
			handleRedirectPayResultPage(path, parms) {
				this.$router.push({ path: `${path}`, query: parms });
			}
		}
	};
</script>

<style lang="scss">
.main{
	position: relative;
	width: 375px;
	// min-height: 100%;
	height: 680px;
	margin: 0 auto;
	background-color: #ffffff;
	border: 1px solid #ebebeb;
}
.cashier-title{
	width: 100%;
	height: 60px;
	background: #ffffff;
}
.logo{
	position: relative;
	width: 100%;
	height: 60px;
	margin: 0 auto;
	padding: 16px 17px;
}
.logo .logo-img{
	width: 219px;
	height: 24px;
}
.logo .logo-close{
	position: absolute;
	top: 50%;
	right: 12px;
	transform: translateY(-50%);
	width: 24px;
	height: 24px;
	cursor: pointer;
}
.banner{
	width: 100%;
	height: 100px;
	background-image: linear-gradient(to right, #8861f5 , #31e6b5);
}
.banner .user-info{
	width: 100%;
	height: 100px;
	margin: 0 auto;
	padding: 15px 0px;
}
.banner .user-info .pay{
	display: flex;
	justify-content: space-between;
	line-height: 18px;
	padding: 0 17px;
	color: #ffffff;
	font-size: 14px;
	font-weight: bold;
}
.banner .user-info .order{
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	line-height: 20px;
	padding: 0 17px 0 17px;
	margin: 0;
	padding-top: 5px;
	line-height: 18px;
	color: #ffffff;
	font-size: 14px;
}
.banner .user-info .order .order-mr {
	margin-right: 35px;
}
.banner .user-info .order span {
	padding: 5px;
}
.main .banner .user-info .order span {
	padding: 0;
}
.content{
	width: 100%;
	// min-height: calc(100vh - 160px);
  padding-bottom: 32px;
	margin: 0 auto;
	height: calc(100% - 202px);
	overflow: hidden;
	overflow-y: auto;
}
.pay .number{
	font-size: 24px;
}
.content .pay-method-select-module {
	padding-top: 9px;
}
.content .pay-method-select-module .pay-method-select-item {
	display: flex;
	height: 60px;
	padding: 0 12px 0 16px;
	align-items: center;
	cursor: pointer;
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-icon {
	display: block;
	margin-right: 12px;
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-icon .pay-method-select-icon-img {
	display: block;
	width: 38px;
	height: 38px;
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-content {
	display: flex;
	flex-grow: 1;
	align-items: center;
	height: 100%;
	border-bottom: 1px solid rgba(217, 217, 217, 0.2);
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-content .pay-method-select-label {
	flex-grow: 1;
	display: block;
	text-align: left;
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-content .pay-method-select-new {
	display: block;
	width: 38px;
	height: 20px;
	background: url(~@/assets/img/pay-method-new.png) 100% 100% no-repeat;
}
.content .pay-method-select-module .pay-method-select-item .pay-method-select-content .pay-method-select-arrow {
	display: block;
	width: 24px;
	height: 24px;
	background: url(~@/assets/img/bank-select-arrow.png) 100% 100% no-repeat;
}
.content .pay-method-use-module {}
.content .pay-method-use-module .pay-method-use-title-module {
	width: 100%;
	height: 52px;
	line-height: 52px;
	margin-bottom: 10px;
	font-family: SFProText-Regular;
	font-size: 16px;
	font-weight: bold;
	text-align: center;
	color: #29303A;
	background-color: #F8F9FA;
}
.safe{
	position: absolute;
	left: 0;
	bottom: 20px;
	width: 100%;
	display: flex;
	line-height: 24px;
	text-align: center;
	justify-content: center;
	color: #8497a4;
}
.safe span{
	display: inline-block;
	height: 24px;
	width: 24px;
	background: url(~@/assets/img/safe.png) left center no-repeat;
}
.safe a{
	color: #1dcf9f;
	padding-left: 10px;
	text-decoration: none;
}
.footer{
	position: absolute;
	left: 0;
	bottom: 10px;
	width: 100%;
	display: flex;
	line-height: 32px;
	text-align: center;
	justify-content: center;
	font-size: 14px;
	color: #8497a4;
}
.footer span{
	display: inline-block;
	height: 24px;
	width: 24px;
	margin-top: 4px;
	background: url(~@/assets/img/safe.png) left center no-repeat;
}
.footer a{
	color: #1dcf9f;
	padding-left: 10px;
	text-decoration: none;
}
.err{
	width: 250px;
	color: #ff2e62;
	text-align: center;
	margin: 0 auto;
}
</style>